const server = {
	version: 'v2.19.2',
	testmode: false,
};

export default ({ app }, inject) => {
	inject('server', server);
};
